<template>
    <div
        id="sponsors-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <sponsor-package
            title="Gold"
            :cost="data.gold.cost"
            :benefits="data.gold.benefits"
            :icon="data.gold.icon"
        />
        <sponsor-package
            title="Silver"
            :cost="data.silver.cost"
            :benefits="data.silver.benefits"
            :icon="data.silver.icon"
        />
        <sponsor-package
            title="Bronze"
            :cost="data.bronze.cost"
            :benefits="data.bronze.benefits"
            :icon="data.bronze.icon"
        />
        <base-text type="p" class="note">
            <em>{{ data.note }}</em>
        </base-text>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/sponsors.md';
    // COMPONENTS
    import SponsorPackage from '../components/SponsorPackage';

    export default {
        name: 'sponsors',

        mixins: [dataLoader(data)],

        components: {
            SponsorPackage,
        },
    };
</script>

<style lang="scss" scoped>
    #sponsors-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }

        .note {
            margin-top: $standard-space;
        }

        &.mobile {
            .note {
                margin-top: $standard-space-mobile;
            }
        }
    }
</style>
